"use client";

import { c as _c } from "react/compiler-runtime";
import { backgroundVariants, Container, classNames, tv } from "@opensea/ui-kit";
import { topStickyVariants } from "@/styles/utils/sticky";
import { useTopNavbarState } from "./hooks";
const topNavbarGradientVariants = tv({
  variants: {
    dark: {
      true: "dark:bg-gradient-to-b dark:from-black/30 dark:to-black/0",
      false: "bg-gradient-to-b from-black/30 to-black/0"
    }
  }
});
const topNavbarBackgroundClassNames = classNames(backgroundVariants({
  background: "primary"
}), "border-b border-border-1");
const topNavbarTransparentBackgroundClassNames = classNames(backgroundVariants({
  background: "primary",
  transparent: true
}), "border-b border-border-1-transparent");
const topNavbarColorTransitionClassNames = classNames("transition-colors duration-200 ease-out-quint");
const topNavbarVariants = tv({
  base: "z-top-navbar flex h-sm-top-nav py-3 lg:h-lg-top-nav",
  variants: {
    transparent: {
      default: topNavbarColorTransitionClassNames,
      topOnly: topNavbarColorTransitionClassNames,
      always: "",
      hidden: "hidden",
      invisible: "pointer-events-none opacity-0",
      none: backgroundVariants({
        background: "primary"
      })
    },
    dark: {
      true: "dark",
      topOnly: ""
    },
    border: {
      true: "",
      false: "border-transparent border-b"
    },
    gradient: {
      true: topNavbarGradientVariants({
        dark: false
      }),
      topOnly: ""
    },
    isScrolledDown: {
      true: ""
    }
  },
  compoundVariants: [{
    transparent: "default",
    isScrolledDown: true,
    className: ""
  }, {
    dark: "topOnly",
    isScrolledDown: false,
    className: "dark"
  }, {
    gradient: "topOnly",
    isScrolledDown: false,
    className: topNavbarGradientVariants({
      dark: false
    })
  }, {
    transparent: "always",
    dark: false,
    gradient: false,
    className: topNavbarTransparentBackgroundClassNames
  }, {
    transparent: "none",
    border: true,
    className: "border-border-1 border-b"
  }],
  defaultVariants: {
    border: true
  }
});
export function TopNavbarContainer(t0) {
  const $ = _c(17);
  const {
    children,
    className,
    isMobile: t1
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isMobile) {
    t2 = {
      isMobile
    };
    $[0] = isMobile;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    height,
    variants,
    scrollPercentage
  } = useTopNavbarState(t2);
  let t3;
  if ($[2] !== className || $[3] !== scrollPercentage || $[4] !== variants) {
    t3 = classNames(topStickyVariants(), topNavbarVariants({
      ...variants,
      isScrolledDown: scrollPercentage === 1
    }), className);
    $[2] = className;
    $[3] = scrollPercentage;
    $[4] = variants;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== height || $[7] !== isMobile || $[8] !== scrollPercentage || $[9] !== variants.transparent) {
    t4 = variants.transparent && ["default", "topOnly"].includes(variants.transparent) ? <div className={classNames("absolute inset-0 -z-10 h-sm-top-nav lg:h-lg-top-nav pointer-events-none", topNavbarBackgroundClassNames)} style={{
      height: height ?? "auto",
      opacity: isMobile || variants.transparent === "topOnly" ? scrollPercentage : 1
    }} /> : null;
    $[6] = height;
    $[7] = isMobile;
    $[8] = scrollPercentage;
    $[9] = variants.transparent;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== children) {
    t5 = <Container className="flex items-center justify-between">{children}</Container>;
    $[11] = children;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = <nav aria-label="Miscellaneous" className={t3}>{t4}{t5}</nav>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}